import { Component } from '@angular/core';
import {NgForOf, NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-info-farmacia',
  standalone: true,
    imports: [
        NgForOf,
        NgOptimizedImage
    ],
  templateUrl: './info-farmacia.component.html',
  styleUrl: './info-farmacia.component.css'
})
export class InfoFarmaciaComponent {

}
